import { List } from 'immutable';
import { connect } from '../../../common/react-redux';
import BanksList from './presenter';
import Bank from '../../../common/records/Bank';
import { openModal, withConfirm } from '../../../common/actions/modal';
import { deleteBank, createBankCloneJob } from '../../api/banks';
import { addInfo } from '../../../common/actions/alerts';
import { addToPolling } from '../../api/copyingBanksPoller';
export function mapStateToProps(state, props) {
  return {
    appContainer: state.getIn(['ui', 'appContainer']),
    banks: List(props.recordIds).map(function (id) {
      return Bank.create(state.getIn(['banks', id]));
    })
  };
}
export default connect(mapStateToProps, {
  openModal: openModal,
  deleteBank: deleteBank,
  withConfirm: withConfirm,
  createBankCloneJob: createBankCloneJob,
  addInfo: addInfo,
  addToPolling: addToPolling
})(BanksList);